import { FC } from 'react';
import { getRouteApi } from '@tanstack/react-router';
import { PrivacyPolicy } from '@frontend/digital-forms-ui';

const routeApi = getRouteApi('/legal/privacy-policy_/$locationId');

export const PrivacyPolicyPage: FC = () => {
  const { locationId } = routeApi.useParams();

  return <PrivacyPolicy locationId={locationId} />;
};
